import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PromoProvider } from '../../providers/promo/promo';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'rmt-promo-row',
  templateUrl: 'rmt-promo-row.html'
})
export class RmtPromoRowComponent {
  @Input() isPromoValid;
  @Input() errorPromo;
  @Input() promoEngineError;
  @Input() promo;
  @Input() newDesign ?: boolean = false; //Todo !! Remove the old design and this parameter after new calculator design merge
  @Input() separator = true;
  promoName;

  @Output() showPromo = new EventEmitter<number>();
  @Output() removePromo = new EventEmitter<number>();

  constructor(private promoProvider: PromoProvider,
              private translate: TranslateService,) {
  }

  getPromoSuccess() {
    if (!this.promo)
      return '';

    this.promoName = this.promoProvider.getPromoName(this.promo);
    let promoSuccess = this.translate.instant('page.promotionsPage.promoApplicableAlert', {class: 'promo-name', promoCode: this.promoName});
    if (this.promo.isPromoEngine && (this.promo.effect || this.promo.hideCode)){
      if (this.promo.hideCode && this.promo.effect && this.promo.effect.length > 0)
        promoSuccess = '<span class="promo-name">' + this.promo.effect +'</span> '
      else
        promoSuccess = '<span class="promo-name">' + this.promoName + '</span> ' + ((this.promo.effect) ? this.promo.effect :"")
    }
    return promoSuccess;
  }

  getPromoInvalid() {
    if (!this.promoName && this.promoEngineError)
      this.promoName = this.promoEngineError.code;
    if (!this.promoName && this.promo)
      this.promoName = this.promo.PromoCode;
    const promoInvalid = this.translate.instant('page.promotionsPage.promoNotApplicableAlert', {class: 'promo-name promo-name_color_warning', promoCode: this.promoName });
    return promoInvalid;
  }

  clickShowPromo() {
    this.showPromo.emit();
  }

  clickRemovePromo(ev) {
    this.removePromo.emit();
    ev.stopPropagation();
    ev.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-promo-row/rmt-promo-row.ts